import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { uploadDocuments } from "_controllers/officer";
import axios from "axios";
import dotenv from "dotenv";
import { useHistory } from "react-router-dom";

dotenv.config();

const Main = () => {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState("");
  const [Values, setValues] = useState({
    documentCategory: "",
    imageUrl: "",
    description: "",
  });
  const [imageLoading, setimageLoading] = useState(false);

  useEffect(async () => {
    const requests = await uploadDocuments();
    setData(requests?.docs);
    setLoading(true);
  }, [message]);

  const { documentCategory, imageUrl, description } = Values;

  //   const handleImage = async (category) => {
  //     const formData = new FormData();
  //     formData.append("file", image);
  //     formData.append("fileName", image.name);
  //     formData.append("type", category);
  //     const token = localStorage.getItem("token");
  //     const config = {
  //       headers: {
  //         "Content-type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };
  //     const url = process.env.REACT_APP_REQUEST_ENDPOINT;
  //     await axios
  //       .post(`${url}/api/v1/document/upload`, formData, config)
  //       .then((res) => {
  //         setImage("");
  //         setMessage(res?.data?.message);
  //         toastMessage(res?.data?.message, "success");
  //       })
  //       .catch((err) => {
  //         setImage("");
  //         setMessage(err?.message);
  //         toastMessage("Select File First.", "error");
  //       });
  //   };

  //   const saveImg = async (e) => {
  //     setImage(e.target.files[0]);
  //     const formData = new FormData();
  //     formData.append("file", image);
  //     formData.append("fileName", image.name);
  //     // formData.append("type", category);
  //     const token = localStorage.getItem("token");
  //     const config = {
  //       headers: {
  //         "Content-type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };
  //     const url = process.env.REACT_APP_REQUEST_ENDPOINT;
  //     await axios
  //       .post(`${url}/api/v1/document/upload/file`, formData, config)
  //       .then((res) => {
  //         console.log("gy", res);
  //         // setImage('')
  //         // setMessage(res?.data?.message)
  //         setValues({ ...Values, ["image"]: "klklkl" });
  //         // toastMessage(res?.data?.message, "success");
  //       })
  //       .catch((err) => {
  //         // setImage("");
  //         // setMessage(err?.message);
  //         // toastMessage("Select File First.", "error");
  //         console.log(err);
  //       });
  //     setValues({ ...Values, ["image"]: e.target.files[0] });
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("submit", Values, image);

    if (image.type === "application/pdf" || image.type === "video/mp4") {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("fileName", image.name);
      formData.append("description", Values.description);
      formData.append("category", Values.documentCategory);
      // const response = await authAxios()({
      //   url: `/api/v1/document`,
      //   method: "POST",
      //   data: Values,
      // });
      // setMessage(response?.data.message);
      // toastMessage("Location Approved", "success");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const url = process.env.REACT_APP_REQUEST_ENDPOINT;
      await axios
        .post(`${url}/api/v1/document`, formData, config)
        .then((res) => {
          // setImage("");
          // setMessage(res?.data?.message);
          console.log("object", res);
          toastMessage(res?.data?.message, "success");
          history.push("/upload-documents");
        })
        .catch((err) => {
          // comment setImage bcoz with catch page wont refresh
          setImage("");
          setMessage(err?.message);
          toastMessage("Select File First.", "error");
        });
    } else {
      return alert("Upload PDF or Video File Only.");
    }
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value });
  };

  const saveImg = async (e) => {
    setImage(e.target.files[0]);
  };

  console.log("ji", Values.image);

  return (
    <>
      <Box
        style={{
          padding: "0px 20px",
          border: "1px solid #eaeaea",
          borderRadius: "10px",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
          // marginTop: "10px",
          marginRight: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid>
          <p style={{ fontWeight: "bolder", fontSize: "1.25rem" }}>
            Create Document
          </p>
        </Grid>
      </Box>

      <Box
        style={{
          marginRight: "20px",
          marginTop: "20px",
        }}
      >
        {/* {loading ? (
          <>
            <TableContainer component={Paper} sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                      Document Type
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                      Description
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                      Uploaded Doc
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                      Last Upload On
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                      Upload
                    </TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data && data?.length > 0 ? (
                    data?.map((d) => (
                      <TableRow key={d._id}>
                        <TableCell align="left">
                          {d?.documentCategory}
                        </TableCell>
                        <TableCell align="left">{d?.description}</TableCell>
                        <TableCell align="center">
                          <a href={d?.url} target="_blank">
                            <PictureAsPdfIcon color="primary" />
                          </a>
                        </TableCell>
                        <TableCell align="center">
                          {d?.dateUploaded.slice(0, 10)}
                        </TableCell>
                        <TableCell align="right">
                          <input type="file" onChange={saveImg} />
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            onClick={() => handleImage(d?.documentCategory)}
                            variant="contained"
                          >
                            Upload
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <Box sx={{ textAlign: "left", pt: 1 }}>
                      <Typography variant="h6" sx={{ p: 1 }}>
                        No Update Request Available.
                      </Typography>
                    </Box>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : (
          <CircularProgress />
        )} */}
        {/* <Box sx={{ flexGrow: 1 }}> */}
        <form onSubmit={handleSubmit}>
          <Grid
            container
            xs={12}
            spacing={1}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <h3>Document Type</h3>
            </Grid>
            <Grid item xs={9}>
              <TextField
                // onKeyPress={handleKeyPress}
                onChange={handleChange}
                value={documentCategory}
                name="documentCategory"
                label="Doc Type"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <h3>Description</h3>
            </Grid>
            <Grid item xs={9}>
              <TextField
                // onKeyPress={handleKeyPress}
                onChange={handleChange}
                value={description}
                name="description"
                label="Description"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={4}>
              <FormControl width={"50%"}>
                <TextField
                  onChange={saveImg}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  type={"file"}
                  id="standard-basic"
                  label="Image"
                  name="image"
                  variant="standard"
                  style={{ border: "0" }}
                />
              </FormControl>
              {/* {imageLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : null}
                {Values.image ? "uploaded !" : null} */}
            </Grid>
          </Grid>
          <br />
          <Grid xs={6}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Grid>
        </form>
      </Box>
    </>
  );
};

const AddDocument = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default AddDocument;
